import { lazy } from 'react';
const Profile = lazy(() => import('../pages/insurance/Profile'));
const User = lazy(() => import('../pages/insurance/users/User'));
const View = lazy(() => import('../pages/insurance/insurance/View'));
const Dashboard = lazy(() => import('../pages/insurance/Dashboard'));
const Insurances = lazy(() => import('../pages/insurance/insurance/Index'));

const InsuranceRoute = [
    { path: '/insurance/users/:page?', name: 'User', component: <User /> },
    { path: '/insurance', name: 'Dashboard', component: <Dashboard /> },
    { path: '/insurance/profile', name: 'User', component: <Profile /> },
    { path: '/insurance/dashboard', name: 'Dashboard', component: <Dashboard /> },
    { path: '/insurance/forms/:type?/:page?', name: 'Insurances', component: <Insurances /> },
    { path: '/insurance/view/:id', name: 'InsuranceView', component: <View /> },
];
export default InsuranceRoute;